import 'node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../ui-lib/theme/hws/css/tiny.min.css';
import '../ui-lib/theme/hws/css/tiny-plus.min.css';
import '../ui-lib/theme/hws/css/tinyext.min.css';
import 'custom/css/pageframework.css';
import 'custom/css/widgets.css';
import './cssLoader';

import {routerConfig} from './routerConfig';

function getSecurityPolicy (){
  var defaultPolicy = {
      'accountpolicy':
      {
          'username_minlen':5,
          'username_maxlen':32,
          'username_contains_char':'^[a-zA-Z\\-][0-9a-zA-Z\\_\\-]+$'
      },
      'passwordpolicy':
      {
          'password_minlen':6,
          'password_maxlen':32,
          'pwd_not_is_the_username_or_invert': 'true',
          'password_char_combination':2
      }
  };
  this.securityPolicy = defaultPolicy;
};

angular.module("tiny", []);
const myApp = angular.module("authui.config", ["ui.router", "wcc", "tiny"]);
getSecurityPolicy.call(myApp);
myApp.factory('securityPolicy', function() {
  return myApp.securityPolicy;
});

routerConfig(myApp);

// 初始化埋点
statistics({
    'ga' : true,
    'hws' : true,
    's99click' : true,
    'ltbt' : false,
    'baidu' : false,
    'cloudbi':true,
});


// WEBPACK FOOTER //
// ./public/hws/index.js